import { GetDevicesResponse } from '@eppendorf/vnls-device-service-utils';
import { QueryClient } from '@tanstack/react-query';

import { prepopulateCache } from '$shared/utils/react-query.utils';

import { MonitoringOverview } from '$features/monitoring';
import { createDevicesV2QueryWithQueryParams } from '$features/monitoring/v2/devicesv2.api';

export async function monitoringLoader(queryClient: QueryClient): Promise<null> {
  return prepopulateCache<GetDevicesResponse>(
    queryClient,
    createDevicesV2QueryWithQueryParams({
      page: 1,
      pageSize: 10,
      searchQuery: '',
      connectionStatus: 'paired',
    }),
  );
}

export function MonitoringPage() {
  return <MonitoringOverview />;
}
